export const Path = {
  // Tour scheduling
  GET_TIMESLOTS: '/tours/schedule',
  CREATE_TOUR: '/tours/schedule',
  GET_TOUR_CONFIRMATION: '/tours/confirmation',
  DELETE_TOUR: '/tours/cancel',

  // Lead inbox
  LEAD_INBOX: '/lead-inbox/',

  // Tour notes
  CREATE_TOUR_NOTES: '/tour-notes',
  GET_TOUR_NOTES_BY_TOURID: '/tour-notes',

  // Leads
  UPDATE_STAGE: '/lead/stage-new',
  QUERY_LEADS: '/leads/query',
  CREATE_LEAD: '/leads/createLead',
  LEAD_BY_ID: leadId => `/leads/${leadId}`,
  LEAD_WAITLIST: leadId => `/leads/${leadId}/waitlist`,
  LEAD_AGENT: leadId => `/leads/${leadId}/agent`,

  // Users
  USER_ME_STATUS: '/users/me/status',
  USER_BY_ID: uid => `/users/${uid}`,
  USER_ME_NOTES: '/users/me/notes',
  // Messages
  MESSAGE_BY_ID: messageId => `/message/${messageId}`,

  // SOP & Announcements
  SOP_ANNOUNCEMENTS: '/sop-announcements',
  SOP_ANNOUNCEMENTS_FOR_AGENT: '/sop-announcements/agent',
  SOP_ANNOUNCEMENTS_ACKNOWLEDGE: '/sop-announcements/acknowledge',

  // Pricing and availability
  GET_COMMUNITY_UNITS: communityId => `/communities/${communityId}/units`,
  GET_COMMUNITY_UNIT: communityId => `/communities/${communityId}/unit`,

  // Phone number management + Voice AI
  GET_AVAILABLE_NUMBER: '/tenant/communityphones',
  DELETE_PHONE_NUMBER: '/tenant/deletePhoneNo',
  PURCHASE_PHONE_NUMBER: '/apartment/phone-number', // NO RECENT HITS BUT STILL WIRED
  GET_PHONE_NUMBERS: '/apartment/phone-numbers', // NO RECENT HITS BUT STILL WIRED
  LOAD_LEAD_SOURCES_FOR_VOICE_AI: '/voiceAi/vanityNumber/load-vanity-numbers',

  // Community management
  COMMUNITIES: '/communities',
  VERIFY_COMMUNITY: '/portal/verifyCommunity',
  INGEST_COMMUNITY: '/portal/ingestCommunities',
  CONFIGURE_INTEGRATION: '/portal/onboardingSettings',
  INGESTED_COMMUNITIES: '/portal/ingestedCommunities',
  CREATE_COMMUNITY_CONFIGS: '/apartment/create-community-configs',
  COMMUNITY_CONFIG: '/community-config',
  COMMUNITY_CONFIG_CHECK_MESSAGING_SERVICE_SENDER:
    '/community-config/check-messaging-service-sender-membership',

  // Client management
  INTERNAL_SETTINGS: '/mandatoryData',
  UPDATE_TENANT: '/tenants',
  CLIENTS: '/clients',
  TENANT_CREATE: '/tenant',

  // Kelsey communication restriction
  RESTRICT_COMMUNICATION: '/portal/restrictCommunication',

  // PMS/CRM Verification
  VERIFY_RENT_CAFE: '/portal/verifyRentCafePropertyCode',

  // Feature flags
  GET_FEATURE_FLAGS: '/features',

  // Knowledge Base and Promotions, Fees
  GET_CORE_KNOWLEDGE: '/knowledge',
  GET_PROMOTIONS: '/promotions',
  GET_FEES: '/fees',

  // Onboarding checklist
  ONBOARDING_CHECK_UNITS: '/onboarding/checks/unit-data',
  ONBOARDING_CHECK_TOUR_SLOTS: '/onboarding/checks/tour-slots',
  ONBOARDING_CHECK_LEAD_SOURCES: '/onboarding/checks/lead-sources',
  ONBOARDING_CHECK_WORKFLOWS: '/onboarding/checks/workflows',
  ONBOARDING_CHECK_AFM_SYNC: '/onboarding/checks/afm-sync',
  ONBOARDING_CHECK_END_TO_END: '/onboarding/checks/end-to-end',
  ONBOARDING_CREATE_LEADS: '/onboarding/leads/create',
  ONBOARDING_SCHEDULE_TOURS: '/onboarding/tours/schedule',
  ONBOARDING_CLEANUP: '/onboarding/cleanup',
  ONBOARDING_INGEST_UNITS: '/onboarding/ingest/unit-data',
  ONBOARDING_CHECK_EXTRA_INTEGRATION_SETTINGS:
    '/onboarding/checks/extra-integration-settings',
  ONBOARDING_CHECK_LEASING_AGENTS: '/onboarding/checks/leasing-agents',
  ONBOARDING_CHECK_CRM_MAPPING: '/onboarding/checks/crm-mapping'
};
